<app-dialog-header [title]="event.title" [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<mat-dialog-content class="background-container"
                    [ngStyle]="{'background-image': 'linear-gradient(to bottom, rgba(255,255,255,0.92) 0%,rgba(255,255,255,0.92) 100%), ' + image}">
  <div class="image-wrapper desktop" *ngIf="!event.boEvent || !event.image" [ngStyle]="{'background-image': image}"></div>
  <app-s3-downloader *ngIf="!utilService.isMobile && event.boEvent && event.image" [model]="event.image" [type]="S3UploaderTypes.Event" [ratio]="S3UploaderRatios.Square"
                     [ownerCentreId]="event.externalOwnerCentreId" [ownerId]="event.eventId" [noBorder]="true"></app-s3-downloader>
  <app-event-info-props *ngIf="eventProps" [eventProps]="eventProps" [showFullLink]="true"></app-event-info-props>
  <mat-tab-group class="desktop dynamic-body" #tabGroup mat-align-tabs="left" animationDuration="0ms"
                 [selectedIndex]="activeTab" (selectedIndexChange)="changeTab($event)">
    <mat-tab label="{{ 'general.api_event_priceinfo' | translate }}"></mat-tab>
    <mat-tab *ngIf="!event.boEvent" label="{{ 'general.api_event_hotinfo' | translate }}"></mat-tab>
    <mat-tab label="{{ 'general.api_event_description' | translate }}"></mat-tab>
    <mat-tab *ngIf="isSeason" label="{{ 'general.api_event_season' | translate }}"></mat-tab>
    <mat-tab *ngIf="!event.boEvent && canEditEventManagers" label="{{ 'general.api_event_managers' | translate }}"></mat-tab>
  </mat-tab-group>
  <div class="tabs-content desktop" #tabsContent>
    <span #priceInfo></span>
    <app-label-value [label]="'general.api_event_priceinfo'" [template]="priceInfoTemplate" [withMargin]="true"></app-label-value>
    <ng-template #priceInfoTemplate>
      <app-html-more *ngIf="event.purchaseDescription?.length" [html]="event.purchaseDescription" [height]="HeightMultiplierEnum.High"></app-html-more>
      <div class="text-muted" *ngIf="!event.purchaseDescription?.length">
        <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
        {{ 'general.api_events_event_purchase_description_empty' | translate }}
      </div>
    </ng-template>
    <ng-container *ngIf="!event.boEvent">
      <hr #hotInfo>
      <app-label-value [label]="'general.api_event_hotinfo'" [template]="hotInfoTemplate" [withMargin]="true"></app-label-value>
      <ng-template #hotInfoTemplate>
        <app-html-more *ngIf="event.hotInfo?.length" [html]="event.hotInfo" [height]="HeightMultiplierEnum.High"></app-html-more>
        <div class="text-muted" *ngIf="!event.hotInfo?.length">
          <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
          {{ 'general.api_events_event_hotinfo_empty' | translate }}
        </div>
      </ng-template>
    </ng-container>
    <hr #description>
    <app-label-value [label]="'general.api_event_description'" [template]="descriptionTemplate" [withMargin]="true"></app-label-value>
    <ng-template #descriptionTemplate>
      <app-html-more class="description" *ngIf="event.description?.length" [html]="event.description" [height]="HeightMultiplierEnum.High"></app-html-more>
      <div class="text-muted" *ngIf="!event.description?.length">
        <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
        {{ 'general.api_events_event_description_empty' | translate }}
      </div>
    </ng-template>
    <ng-container *ngIf="isSeason">
      <hr #season>
      <app-label-value [label]="'general.api_event_season'" [template]="seasonTemplate" [withMargin]="true"></app-label-value>
      <ng-template #seasonTemplate>
        <span>{{ 'general.api_event_season_description' | translate }}:</span>
        <ul>
          <li *ngFor="let seasonEvent of seasonEvents">
            {{ seasonEvent.title }} <ng-container *ngIf="seasonEvent.eventDate">{{ seasonEvent.eventDate | period: { hasTimeInPeriod: true } }}</ng-container>
          </li>
        </ul>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!event.boEvent && canEditEventManagers">
      <hr>
      <app-label-value #managers [title]="'general.api_event_managers'" [template]="eventManagersTemplate"></app-label-value>
      <ng-template #eventManagersTemplate>
        <table class="max-width">
          <tbody>
          <tr>
            <td class="quarter-width bold">
              <div [ngClass]="{'top-spacer': isEdit}">
                {{ 'general.api_event_managers_description' | translate }}:
              </div>
            </td>
            <td>
              <div *ngIf="!isEdit">
                <div class="left-spacer" *ngFor="let manager of eventManagers">
                  {{ manager.name }}
                </div>
                <ng-container *ngIf="!eventManagers.length">
                  {{ 'general.api_event_managers_empty' | translate }}
                </ng-container>
              </div>
              <div *ngIf="isEdit" #managersEdit>
                <mat-form-field appearance="outline">
                  <mat-select *ngIf="availableManagers.length < 1" [(ngModel)]="updatedManagers">
                    <mat-option disabled>{{'general.api_event_no_available_managers' | translate}}</mat-option>
                  </mat-select>
                  <mat-select *ngIf="availableManagers.length > 0" [(ngModel)]="updatedManagers" multiple>
                    <mat-option *ngFor="let manager of availableManagers" [value]="manager.userId">{{ manager.firstName + " " + manager.lastName }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </ng-container>
  </div>
  <div class="mobile">
    <div (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
      <mat-tab-group class="mobile" mat-align-tabs="left" animationDuration="300ms" [selectedIndex]="activeTab">
        <mat-tab label="{{ 'general.api_event_priceinfo' | translate }}">
          <ng-template matTabContent>
            <app-html-more *ngIf="event.purchaseDescription?.length" [html]="event.purchaseDescription" [height]="HeightMultiplierEnum.High"></app-html-more>
            <div class="text-muted" *ngIf="!event.purchaseDescription?.length">
              <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
              {{ 'general.api_events_event_purchase_description_empty' | translate }}
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="{{ 'general.api_event_hotinfo' | translate }}" *ngIf="!event.boEvent">
          <ng-template matTabContent>
            <app-html-more *ngIf="event.hotInfo?.length" [html]="event.hotInfo" [height]="HeightMultiplierEnum.High"></app-html-more>
            <div class="text-muted" *ngIf="!event.hotInfo?.length">
              <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
              {{ 'general.api_events_event_hotinfo_empty' | translate }}
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="{{ 'general.api_event_description' | translate }}">
          <ng-template matTabContent>
            <app-html-more *ngIf="event.description?.length" [html]="event.description" [height]="HeightMultiplierEnum.High"></app-html-more>
            <div class="text-muted" *ngIf="!event.description?.length">
              <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
              {{ 'general.api_events_event_description_empty' | translate }}
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab *ngIf="isSeason" label="{{ 'general.api_event_season' | translate }}">
          <ng-template matTabContent>
            {{ 'general.api_event_season_description' | translate }}:
            <ul>
              <li *ngFor="let seasonEvent of seasonEvents">
                {{ seasonEvent.title }} <ng-container *ngIf="seasonEvent.eventDate">{{ seasonEvent.eventDate | period: { hasTimeInPeriod: true } }}</ng-container>
              </li>
            </ul>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div *ngIf="!event.boEvent && canEditEventManagers">
      <hr>
      <div class="heading-3 bold">{{ 'general.api_event_managers' | translate }}</div>
      <div>
        <mat-form-field appearance="outline" class="event-managers">
          <mat-select *ngIf="availableManagers.length < 1" [(ngModel)]="updatedManagers">
            <mat-option disabled>{{'general.api_event_no_available_managers' | translate}}</mat-option>
          </mat-select>
          <mat-select *ngIf="availableManagers.length > 0" [(ngModel)]="updatedManagers" multiple>
            <mat-option *ngFor="let manager of availableManagers" [value]="manager.userId">{{ manager.firstName + " " + manager.lastName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <div class="left-spacer" *ngFor="let manager of eventManagers">
          {{ manager.name }}
        </div>
        <div *ngIf="!eventManagers.length" class="top-spacer">
          {{ 'general.api_event_managers_empty' | translate }}
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
  <button mat-button (click)="confirmClose()" *ngIf="!isEdit || utilService.isMobile">
    {{ 'general.api_general_close' | translate }}
  </button>
  <ng-container *ngIf="!event.boEvent && canEditEventManagers">
    <button mat-stroked-button color="primary" *ngIf="!isEdit && !utilService.isMobile" (click)="editManagers()">{{ 'general.api_event_managers_edit' | translate }}</button>
    <button mat-stroked-button color="primary" *ngIf="isEdit && !utilService.isMobile" (click)="isEdit = false">{{ 'general.api_event_managers_cancel' | translate }}</button>
    <button mat-stroked-button color="primary" *ngIf="isEdit || utilService.isMobile" (click)="save()">{{ 'general.api_event_managers_save' | translate }}</button>
  </ng-container>
  <button mat-stroked-button color="primary" (click)="navigateToSelfServiceView()" *ngIf="canViewSelfServiceEvent">
    {{ 'general.api_general_to_event_detail_view' | translate }}
  </button>
  <button mat-flat-button color="primary" *ngIf="!isEdit && displayNavigateToEvent && eventService.displaySaleActions(event)" (click)="navigateToEvent()"
          [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent)">
    {{ 'general.api_general_to_event' | translate }}
  </button>
</ng-template>
